import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../Api"; // your API constant
import CardLoader from "./Loader/CardLoader";
import { useLocation } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import poster from '../Assets/poster.png'

export default function PlacementShowcase() {
  const [placements, setPlacements] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation(); // get current URL

  useEffect(() => {
    const getPlacements = async () => {
      try {
        const res = await axios.get(`${API}/api/placements`);
        setPlacements(res.data);
      } catch (err) {
        console.error("Error fetching placements:", err);
      } finally {
        setLoading(false);
      }
    };

    getPlacements();
  }, []);

  // Helper function to build full image URL
  const getImageUrl = (file) => {
    if (!file) return "https://via.placeholder.com/300"; // fallback
    return `${API}/uploads/${file}`;
  };

  // Sort placements by package in descending order
  const sortedPlacements = [...placements].sort(
    (a, b) => parseFloat(b.package) - parseFloat(a.package)
  );

  // Determine which placements to show
  const displayedPlacements =
    location.pathname === "/" ? sortedPlacements.slice(0, 4) : sortedPlacements;

  return (
    <>
      <style>{`
        .placement-section { max-width: 1100px; margin: 0 auto; padding: 50px 20px; font-family: 'Segoe UI', sans-serif; }
        .placement-heading { text-align: center; font-size: 2.5rem; font-weight: bold; margin-bottom: 40px; color: #1F2661; }
        .placement-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 30px; }
        .placement-card { background: white; overflow: hidden; box-shadow: 0 6px 20px rgba(0,0,0,0.08); transition: transform 0.3s ease, box-shadow 0.3s ease; position: relative; height: 100%; }
        .testimonial-card {
         height: 100%; 
        }
        .placement-card:hover { transform: translateY(-8px); box-shadow: 0 12px 30px rgba(0,0,0,0.12); }
        .placement-photo { width: 70%; height: 200px; object-fit: cover; 
        
    /*    clip-path: polygon(
    25% 0%, 75% 0%, 
    100% 50%, 75% 100%, 
    25% 100%, 0% 50%
  ); */
  outline: 2px solid #f6f7f7ff;

   border-radius: 50%;
   
  } 
       .hl {
        text-transform: uppercase;
        font-size: 25px;

       }
        .main-headline {
         margin-bottom: 20px;
        }
        .placement-content { padding: 20px; text-align: center; }
        .student-name { font-size: 1.3rem; font-weight: bold; margin-bottom: 8px; color: #111827; color: #fff;}
        .placed-role {
         color: #f0d71bff;
         font-size: 18px;
         text-transform: uppercase;
         text-shadow: 1px 1px 3px #dac207ff;
         
        }
        .student-role { font-size: 1rem; color: #d2d4d6ff; margin-bottom: 12px;margin: 10px 0px; }
        .company-name { font-size: 1rem; color: #18c1dbff; font-weight: 500; margin-bottom: 8px; text-align: center; margin: 10px 0px; }
        .lpa-badge { display: inline-block; background: #fbbf24; color: #000; padding: 6px 12px; border-radius: 20px; font-weight: bold; font-size: 0.9rem;margin: 10px 0px; }
      `}</style>

      <section className="placement-section">
        <h2 className="main-headline">Our Proud Placements</h2> 


        <div className="placement-grid">
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <CardLoader />
              <CardLoader />
              <CardLoader />
            </div>
          ) : displayedPlacements.length === 0 ? (
            <p>No placements found.</p>
          ) : (
            displayedPlacements.map((p,i) => {
              const student = p.student;
              const company = p.company;

              return (
                <div key={p._id}>
                  <Fade  className="placement-card ">
                <div className="testimonial-card" style={{background: `url(${poster})`, backgroundRepeat:'no-repeat', backgroundSize: 'cover', textAlign: 'center', padding: '30px 0px'}}>
                          
                    <img
                      src={
                        student
                          ? getImageUrl(student.studentImage)
                          : getImageUrl(company.companyImage)
                      }
                      alt={student ? student.studentName : company.companyName}
                      className="placement-photo"
                    />
                    <div className="placement-content">
                      <h3 className="student-name hl">
                        {student ? student.studentName : company.companyName}
                      </h3>
                      <p  className="student-role">{student?.studentEducation && student.studentEducation[0]}</p>
                      <p className="placed-role">{p.jobRole}</p>
                      <p className="company-name">{company.companyName}</p>
                      <span className="lpa-badge">{p.package}</span>
                    </div>
                    </div>
                  </Fade>
                </div>
              );
            })
          )}
        </div>
      </section>
    </>
  );
}
